import {
  bluePaletteDark,
  grayPaletteDark,
  greenPaletteDark,
  redPaletteDark,
  royalBluePaletteDark,
  yellowPaletteDark,
} from '../../themes/dark-colors';

export const inlineNotificationDarkTheme = {
  variants: {
    success: {
      light: {
        icon: 'circle-check-solid' as const,
        textColor: royalBluePaletteDark[1000],
        backgroundColor: greenPaletteDark[100],
        accentColor: greenPaletteDark[500],
        iconColor: greenPaletteDark[500],
      },
      bold: {
        icon: 'circle-check-solid' as const,
        textColor: royalBluePaletteDark[1000],
        backgroundColor: greenPaletteDark[500],
        accentColor: greenPaletteDark[600],
        iconColor: royalBluePaletteDark[1000],
      },
    },
    warning: {
      light: {
        icon: 'triangle-exclamation-solid' as const,
        textColor: royalBluePaletteDark[1000],
        backgroundColor: yellowPaletteDark[300],
        accentColor: yellowPaletteDark[700],
        iconColor: yellowPaletteDark[700],
      },
      bold: {
        icon: 'triangle-exclamation-solid' as const,
        textColor: royalBluePaletteDark[1000],
        backgroundColor: yellowPaletteDark[600],
        accentColor: yellowPaletteDark[800],
        iconColor: royalBluePaletteDark[1000],
      },
    },
    danger: {
      light: {
        icon: 'diamond-exclamation-solid' as const,
        textColor: royalBluePaletteDark[1000],
        backgroundColor: redPaletteDark[100],
        accentColor: redPaletteDark[600],
        iconColor: redPaletteDark[600],
      },
      bold: {
        icon: 'diamond-exclamation-solid' as const,
        textColor: grayPaletteDark[0],
        backgroundColor: redPaletteDark[600],
        accentColor: redPaletteDark[700],
        iconColor: grayPaletteDark[0],
      },
    },
    announcement: {
      light: {
        icon: 'bullhorn-solid' as const,
        textColor: royalBluePaletteDark[1000],
        backgroundColor: bluePaletteDark[200],
        accentColor: bluePaletteDark[700],
        iconColor: bluePaletteDark[800],
      },
      bold: {
        icon: 'bullhorn-solid' as const,
        textColor: grayPaletteDark[0],
        backgroundColor: bluePaletteDark[700],
        accentColor: bluePaletteDark[800],
        iconColor: grayPaletteDark[0],
      },
    },
    info: {
      light: {
        icon: 'circle-info-solid' as const,
        textColor: royalBluePaletteDark[1000],
        backgroundColor: grayPaletteDark[200],
        accentColor: grayPaletteDark[700],
        iconColor: grayPaletteDark[700],
      },
      bold: {
        icon: 'circle-info-solid' as const,
        textColor: grayPaletteDark[0],
        accentColor: grayPaletteDark[800],
        backgroundColor: grayPaletteDark[700],
        iconColor: grayPaletteDark[0],
      },
    },
  },
};
